import { render, staticRenderFns } from "./IconInstagram.vue?vue&type=template&id=66005a06&"
import script from "./IconInstagram.vue?vue&type=script&lang=ts&"
export * from "./IconInstagram.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports